import React from 'react';
import { ReactElement } from 'react';
import { IRoute } from 'interfaces/routesInt';
import ManageRoutes from 'routes/manageRoute';
import urls from 'routes/urls';

const protectedPageElement: ReactElement = <ManageRoutes />;
const commonElements = {
  element: protectedPageElement,
  isProtected: true,
};

const protectedRoutes: IRoute[] = [
  {
    path: urls.dashboard,
    key: urls.dashboard,
    ...commonElements,
  },
  {
    path: urls.sales,
    key: urls.sales,
    ...commonElements,
  },
  {
    path: urls.inventory,
    key: urls.inventory,
    ...commonElements,
  },
  {
    path: urls.products,
    key: urls.products,
    ...commonElements,
  },
  {
    path: urls.funds,
    key: urls.funds,
    ...commonElements,
  },
  {
    path: urls.archivedStock,
    key: urls.archivedStock,
    ...commonElements,
  },
  {
    path: urls.settings,
    key: urls.settings,
    ...commonElements,
  },
  {
    path: urls.customers,
    key: urls.customers,
    ...commonElements,
  },
  {
    path: urls.productCategory,
    key: urls.productCategory,
    ...commonElements,
  },
  {
    path: urls.debts,
    key: urls.debts,
    ...commonElements,
  },
  {
    path: urls.pageNotFound,
    key: urls.pageNotFound,
    ...commonElements,
  },
  {
    path: urls.suppliers,
    key: urls.suppliers,
    ...commonElements,
  },
  {
    path: urls.manageBranchs,
    key: urls.manageBranchs,
    ...commonElements,
  },
  {
    path: urls.stock,
    key: urls.stock,
    ...commonElements,
  },
];

export default protectedRoutes;
